import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { TranslationOptionsService } from './service/translation-options.service';

@Component({
  selector: 'app-translation-options',
  imports: [
    FormsModule,
    MatInputModule,
    MatSelectModule,
    MatFormFieldModule,
    TranslateModule,
  ],
  templateUrl: './translation-options.component.html',
  styleUrl: './translation-options.component.scss',
})
export class TranslationOptionsComponent {
  translationOptions = inject(TranslationOptionsService);
}
